<form [formGroup]="categoryForm" class="dialog-root">
  @if (data.categoryDto) {
    <h2 mat-dialog-title>{{"category.edit_category" | transloco}}</h2>
  } @else {
    <h2 mat-dialog-title>{{"category.add_category" | transloco}}</h2>
  }

  <mat-dialog-content class="row-gap">
    <div class="column-gap">
      <mat-card class="width-flex">
        <mat-card-content class="column">
          <mat-tab-group class="column-stretch" formArrayName="name">
            @for (group of name.controls; let i = $index; track $index) {
              <mat-tab [label]="group.value.language | language">
                <mat-form-field hideRequiredMarker="true" [formGroupName]="i" class="tab-body">
                  <mat-label>{{ "form.label.name" | transloco }}</mat-label>
                  <input matInput formControlName="value">
                </mat-form-field>
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-content>
          <mat-tab-group class="column-stretch" formArrayName="categoryGroup">
            @for (group of categoryGroup.controls; let i = $index; track $index) {
              <mat-tab [label]="group.value.language | language">
                <mat-form-field hideRequiredMarker [formGroupName]="i" class="tab-body">
                  <mat-label>{{ "form.label.category_group" | transloco }}</mat-label>

                  <input matInput formControlName="value" [matAutocomplete]="auto" />

                  <mat-autocomplete #auto="matAutocomplete">
                    @for (categoryGroup of categoryGroups(group.value.language); track categoryGroup) {
                      <mat-option [value]="categoryGroup">{{ categoryGroup }}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-content>
          <mat-tab-group class="column-stretch" formArrayName="bookingHint">
            @for (group of bookingHint.controls; let i = $index; track $index) {
              <mat-tab [label]="group.value.language | language">
                <mat-form-field hideRequiredMarker="true" [formGroupName]="i" class="tab-body">
                  <mat-label>{{ "form.label.booking_hint_optional" | transloco }}</mat-label>
                  <textarea matInput rows="3" formControlName="value"></textarea>
                </mat-form-field>
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card class="width-flex">
      <mat-card-content class="column">
        <mat-form-field>
          <mat-label>{{"form.label.location" | transloco}}</mat-label>
          <mat-select formControlName="locationId">
            @for (locationId of locationIds; track $index) {
              <mat-option [value]="locationId">{{ locationName(locationId) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{"form.label.appointment_duration_minutes" | transloco}}</mat-label>
          <input formControlName="appointmentDurationMinutes" matInput type="text" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{"form.label.appointment_slot_minutes" | transloco}}</mat-label>
          <input formControlName="slotDurationMinutes" matInput type="text" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{"form.label.start_time_interval_optional" | transloco}}</mat-label>
          <input formControlName="startTimeIntervalMinutes" matInput type="text" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{"form.label.appointment_frequency_optional" | transloco}}</mat-label>
          <mat-select formControlName="maxAppointmentFrequency">
            @for (id of [undefined, 0, 1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
              <mat-option [value]="id">{{ id | appointmentDistance }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"form.label.price" | transloco}}</mat-label>
          <input formControlName="price" matInput type="text" />
        </mat-form-field>

        <div class="row-gap-small-center">
          <button (click)="restrictBookingTimes()" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          @if (bookingConstraints.value.length > 0) {
            <p>{{ "label.booking_constraints.yes" | transloco }}</p>
          } @else {
            <p>{{ "label.booking_constraints.no" | transloco }}</p>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" mat-button type="button">{{"button.cancel" | transloco}}</button>

    @if (data.categoryDto) {
      <button mat-flat-button (click)="manage()">{{ "button.save" | transloco }}</button>
    } @else {
      <button mat-flat-button (click)="manage()">{{ "category.add_category" | transloco }}</button>
    }
  </mat-dialog-actions>
</form>
